<template>
  <div class='card block-shadow'>
    <div class="card__title" v-bind:style="{ background: cardOptions.headerColor }">
      <span>
        {{ cardOptions.name.first }}
      </span>
      <span v-if="cardOptions.name.second">
        <span v-if="!cardOptions.name.detailsLink">
          {{ cardOptions.name.second }}
        </span>
        <router-link v-if="cardOptions.name.detailsLink" class="card__title__link"
                     :to="cardOptions.name.detailsLink">
          {{ cardOptions.name.second }}
        </router-link>
      </span>
    </div>
    <div class="card__content">
      <div class="card__first-col">
        <ul v-for='(advantage, index) in cardOptions.advantages' :key="index" class="card__first-col__product-desc">
          <li class="card__first-col__product-desc__item">
            <img class="icon" :src="advantage.icon" alt="">
            <span class="text" v-html="advantage.text">
          </span>
          </li>
        </ul>
      </div>

      <div class="card__second-col">
        <div class="card__second-col__main-text"
             v-bind:style="{ color: cardOptions.texts.main.color }"
             v-html="cardOptions.texts.main.text"></div>
        <div class="card__second-col__second-text"
             v-bind:style="{ color: cardOptions.texts.second.color }"
             v-html="cardOptions.texts.second.text">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardItemSingle",
  props: ['cardOptions']

}
</script>

<style scoped>
.card {
  min-height: 300px;
  border-radius: 25px;
  background-color: #f3f3f3;
  overflow: hidden;
  /*min-width: 800px;*/
  margin-bottom: 25px;
}

.card:not(:first-child) {
  margin-left: 30px;
}

.card__title {
  height: 60px;
  padding: 0 15px;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e76d82;
  line-height: 30px;
  color: #ffffff;
  font-size: 26px;
}

.card__title__link {
  color: white;
}

.card__content {
  flex-direction: row;
  display: flex;
  padding: 15px 20px;
}
.card__first-col {
  padding: 15px 0 0 0;
  width: 50%;
}

.card__first-col__product-desc__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 0 0 15px 0;
}

.card__first-col__product-desc__item > .text {
  margin-left: 20px;
  line-height: 24px;
  font-size: 22px;
  color: rgba(0, 0, 0, 0.6);
}

.card__second-col {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 15px 0;
  border-left: 2px solid #ccc;
}
.card__second-col__main-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 40px;
}

.card__second-col__second-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #787878;
  font-size: 12px;
}

@media (max-width: 800px) {
  .card {
    margin-left: 0 !important;
    width: auto;
    margin-bottom: 15px;
  }
  .card__first-col {
    padding: 0 15px 0 0;
  }
  .card__second-col__main-text {
    font-size: 32px;
  }
  .card__first-col__product-desc__item .text {
    font-size: 20px;
    line-height: 24px;
  }
}
@media (max-width: 600px) {
  .card__content {
    flex-direction: column;
    align-items: center;
  }
  .card__first-col {
    width: 100%;
  }
  .card__second-col {
    border-left: none;
    border-top: 2px solid #cccccc;
    width: 100%;
    margin-top: 15px;
  }
  .card__second-col__main-text {
  }
}

@media (max-width: 400px) {
  .card__title {
    font-size: 24px;
  }
  .card__content {
    min-width: auto;
    padding: 15px;
  }
}
</style>
